// react_frontend/src/Components/Layouts/Login.js
import React from 'react'
import {Outlet} from "react-router-dom";

const Login = () => {
  return (
         <Outlet />
  )
}

export default Login